(() => {
  if (window.mnSharedCustomizeDrawer) return;

  const getDrawer = () => {
    const drawer = document.querySelector('[data-mn-shared-customize-drawer]');
    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
    return drawer;
  };
  let pageState = null;
  let giftbox = null;
  let giftboxPlaceholder = null;
  let giftboxBackdrop = null;
  let giftboxObserver = null;
  let giftboxCartCloseTimer = null;

  const sharedDrawer = getDrawer();
  sharedDrawer?.addEventListener('wheel', (event) => {
    if (!sharedDrawer.classList.contains('is-open') || window.innerWidth < 1000) return;
    if (Math.abs(event.deltaX) > 1 && Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
      if (event.cancelable) event.preventDefault();
    }
  }, { capture: true, passive: false });

  const lockPage = () => {
    if (pageState) return;

    const body = document.body;
    const html = document.documentElement;
    const desktop = window.innerWidth >= 768;

    pageState = {
      mode: desktop ? 'desktop' : 'fixed',
      scrollY: window.scrollY,
      body: {
        position: body.style.position,
        top: body.style.top,
        right: body.style.right,
        left: body.style.left,
        width: body.style.width,
        overflow: body.style.overflow,
        paddingRight: body.style.paddingRight
      },
      htmlOverflow: html.style.overflow
    };

    const scrollbarWidth = window.innerWidth - html.clientWidth;
    if (scrollbarWidth > 0) {
      body.style.paddingRight = `${scrollbarWidth}px`;
    }

    /*
     * Desktop:
     * Main Product använder position: sticky. Att göra hela body position:fixed
     * ändrar window.scrollY/sticky-state och gav ett synligt hopp när
     * Anpassa-drawern stängdes. Lås därför desktop på samma sätt som temats
     * vanliga drawers: bara overflow:hidden.
     *
     * Mobil:
     * Behåll fixed-body-låset för att förhindra iOS-scroll bakom drawern.
     */
    if (desktop) {
      body.style.overflow = 'hidden';
    } else {
      body.style.position = 'fixed';
      body.style.top = `-${pageState.scrollY}px`;
      body.style.right = '0';
      body.style.left = '0';
      body.style.width = '100%';
      body.style.overflow = 'hidden';
      html.style.overflow = 'hidden';
    }

    body.classList.add('mn-shared-customize-open');
  };

  const unlockPage = () => {
    if (!pageState) return;

    const body = document.body;
    const html = document.documentElement;
    const state = pageState;
    pageState = null;

    body.style.position = state.body.position;
    body.style.top = state.body.top;
    body.style.right = state.body.right;
    body.style.left = state.body.left;
    body.style.width = state.body.width;
    body.style.overflow = state.body.overflow;
    body.style.paddingRight = state.body.paddingRight;
    html.style.overflow = state.htmlOverflow;
    body.classList.remove('mn-shared-customize-open');

    if (state.mode === 'fixed') {
      window.scrollTo(0, state.scrollY);
    }
  };

  const getTemplate = (button) => {
    const pdpId = String(button?.dataset?.pdpId || '').trim();
    if (!pdpId) return null;
    // Explicit recommendation context must never resolve a main-product/free-gift
    // template with the same product ID on PDPs.
    if (button.dataset.mnContext === 'cart-recommendation') {
      return document.querySelector(
        `#mak-cart-drawer template[data-mn-customize-template][data-mn-context="cart-recommendation"][data-pdp-id="${pdpId}"]`
      );
    }
    const productItem = button.closest('.mak_product-item');
    if (productItem) {
      const local = productItem.querySelector(
        `template[data-mn-customize-template][data-pdp-id="${pdpId}"]`
      );
      if (local) return local;
    }
    const quickView = button.closest('.cart_quick_view_popup');
    if (quickView) {
      const cartTemplate = document.querySelector(
        `template[data-mn-customize-template][data-mn-context="cart-recommendation"][data-pdp-id="${pdpId}"]`
      );
      if (cartTemplate) return cartTemplate;
    }
    return document.querySelector(
      `template[data-mn-customize-template][data-pdp-id="${pdpId}"]`
    );
  };

  const resetCustomizeDefaultVariant = (content) => {
    const variants = content.querySelector('.mak__variants-main');
    const select = variants?.querySelector('select[name="id"]');
    if (!select?.options.length) return;

    const defaultOption = Array.from(select.options).find((option) =>
      !/\s-\s(?:slutsåld|slut i lager|sold out|utsolgt|udsolgt|ausverkauft|uitverkocht|agotado|loppuunmyyty)\s*$/i.test(option.textContent)
    ) || select.options[0];
    const values = normalizeVariantText(defaultOption.getAttribute('data-name')).split(' / ');

    variants.querySelectorAll('fieldset.option-selector').forEach((fieldset, index) => {
      const radio = Array.from(fieldset.querySelectorAll('.mak_variants_radio')).find((input) =>
        normalizeVariantText(input.value) === normalizeVariantText(values[index])
      );
      if (!radio) return;
      radio.checked = true;

      const label = Array.from(fieldset.querySelectorAll('label[for]')).find((item) =>
        item.getAttribute('for') === radio.id
      );
      const selectedLabel = fieldset.querySelector('.mak_slected-variant');
      if (selectedLabel) {
        selectedLabel.textContent = (label?.querySelector('.js-value, [data-name-variant]')?.textContent || radio.value).trim();
      }
    });
    select.value = defaultOption.value;
  };

  const bindTrackpad = ($main) => {
    $main.off('wheel.mnSharedCustomizeImages');

    const desktopQuery = window.matchMedia('(min-width: 1000px)');
    if (!desktopQuery.matches) return;

    let horizontalLocked = false;
    let horizontalAccumulator = 0;
    let horizontalDirection = 0;
    let lastHorizontalEventAt = 0;
    let lastHorizontalAbsDelta = 0;
    let lastTriggerAt = 0;

    $main.on('wheel.mnSharedCustomizeImages', (event) => {
      if (!$main.hasClass('slick-initialized')) return;

      const originalEvent = event.originalEvent || event;
      const deltaX = Number(originalEvent.deltaX || 0);
      const deltaY = Number(originalEvent.deltaY || 0);
      const absX = Math.abs(deltaX);

      /* Bara horisontella tvåfingers-gester. */
      if (
        absX < 2 ||
        absX <= Math.abs(deltaY)
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      const now = performance.now();
      const direction = deltaX > 0 ? 1 : -1;
      const sinceLastEvent = now - lastHorizontalEventAt;
      const sinceTrigger = now - lastTriggerAt;

      /*
       * Ett trackpad-swipe = exakt en bild.
       * Momentum-svansen från samma swipe ignoreras.
       * Ett nytt tydligt swipe kan däremot göras direkt efteråt.
       *
       * Detta är samma gesture-logik som fungerade i den gamla
       * Main Product Anpassa-drawern och fungerar även efter slickFilter.
       */
      if (horizontalLocked) {
        const clearNewGestureGap = sinceLastEvent > 140;
        const newImpulse =
          sinceTrigger > 260 &&
          absX >= 10 &&
          absX > Math.max(10, lastHorizontalAbsDelta * 1.75);

        if (clearNewGestureGap || newImpulse) {
          horizontalLocked = false;
          horizontalAccumulator = 0;
          horizontalDirection = 0;
        } else {
          lastHorizontalEventAt = now;
          lastHorizontalAbsDelta = absX;
          return;
        }
      }

      if (horizontalDirection && horizontalDirection !== direction) {
        horizontalAccumulator = 0;
      }

      horizontalDirection = direction;
      horizontalAccumulator += deltaX;
      lastHorizontalEventAt = now;
      lastHorizontalAbsDelta = absX;

      if (Math.abs(horizontalAccumulator) < 24) return;

      horizontalAccumulator = 0;
      horizontalLocked = true;
      lastTriggerAt = now;

      const slick = $main.slick('getSlick');
      const currentSlide = Math.round(
        Number($main.slick('slickCurrentSlide')) || 0
      );
      const lastSlide = Math.max(0, slick.slideCount - 1);

      if (direction > 0 && currentSlide < lastSlide) {
        $main.slick(
          'slickGoTo',
          Math.min(currentSlide + 1, lastSlide),
          false
        );
      } else if (direction < 0 && currentSlide > 0) {
        $main.slick(
          'slickGoTo',
          Math.max(currentSlide - 1, 0),
          false
        );
      }
    });
  };

  const initGallery = (content) => {
    if (!window.jQuery?.fn?.slick) return;
    const $ = window.jQuery;
    const main = content.querySelector('.product-main-slider');
    const nav = content.querySelector('.product-nav-slider');
    if (!main) return;
    if (!main.dataset.mnTouchZonesReady) {
      main.dataset.mnTouchZonesReady = 'true';
      let blockVerticalScroll = false;
      main.addEventListener('touchstart', (event) => {
        blockVerticalScroll = false;
        if (window.innerWidth >= 1000 || event.touches.length !== 1) return;
        const bounds = main.querySelector('.slick-list')?.getBoundingClientRect();
        if (!bounds) return;
        const y = event.touches[0].clientY;
        blockVerticalScroll = y >= bounds.top && y < bounds.top + bounds.height * 0.90;
      }, { passive: true });
      main.addEventListener('touchmove', (event) => {
        if (blockVerticalScroll && event.cancelable) event.preventDefault();
      }, { capture: true, passive: false });
      ['touchend', 'touchcancel'].forEach((type) => {
        main.addEventListener(type, () => { blockVerticalScroll = false; }, { passive: true });
      });
    }
    const $main = $(main);
    const $nav = nav ? $(nav) : null;

    /* Respektera den AKTIVA bildens/videons verkliga bildförhållande.
       Slick har flera slides samtidigt (1.07 st på mobil), så en annan
       4:5-slide får inte behålla sin höjd när den aktiva videon är 9:10. */
    const updateActiveMediaRatio = (slick, index) => {
      if (window.innerWidth >= 1000) return;
      const slides = slick?.$slides?.toArray?.() || [];
      const slide = slides[index] || slides[0];
      if (!slide) return;
      const video = slide.querySelector('video');
      const image = slide.querySelector('.mn-pdp-video-preview img, img');
      let width = video?.videoWidth || 0;
      let height = video?.videoHeight || 0;
      if (!width || !height) {
        width = image?.naturalWidth || Number(image?.getAttribute('width')) || 0;
        height = image?.naturalHeight || Number(image?.getAttribute('height')) || 0;
      }
      if (!width || !height) return;
      const ratio = width / height;
      if (!Number.isFinite(ratio) || ratio < 0.4 || ratio > 2.5) return;
      const nextRatio = `${width} / ${height}`;
      if (main.style.getPropertyValue('--mn-drawer-active-ratio') === nextRatio) return;
      main.style.setProperty('--mn-drawer-active-ratio', nextRatio);
      window.requestAnimationFrame(() => {
        if ($main.hasClass('slick-initialized')) $main.slick('setPosition');
      });
    };
    $main.off('.mnDrawerAspect');
    $main.on('init.mnDrawerAspect reInit.mnDrawerAspect afterChange.mnDrawerAspect setPosition.mnDrawerAspect',
      (event, slick, index) => updateActiveMediaRatio(slick, Number.isInteger(index) ? index : slick.currentSlide || 0));
    $main.on('beforeChange.mnDrawerAspect', (event, slick, oldIndex, nextIndex) => {
      updateActiveMediaRatio(slick, nextIndex);
    });
    main.querySelectorAll('.main-pdp video, .main-pdp > img, .mn-pdp-video-preview img').forEach((media) => {
      media.addEventListener(media.tagName === 'VIDEO' ? 'loadedmetadata' : 'load', () => {
        if ($main.hasClass('slick-initialized')) {
          const slick = $main.slick('getSlick');
          updateActiveMediaRatio(slick, slick.currentSlide || 0);
        }
      }, { passive: true });
    });
    if ($main.hasClass('slick-initialized')) $main.slick('unslick');
    if ($nav?.hasClass('slick-initialized')) $nav.slick('unslick');
    $main.slick({
      slidesToShow: window.matchMedia('(min-width: 1000px)').matches ? 1.09 : 1.07,
      // Matcha Main Collection: fasta slidebredder pa mobil behover variableWidth.
      variableWidth: window.matchMedia('(max-width: 768px)').matches,
      slidesToScroll: 1,
      speed: 300,
      infinite: false,
      arrows: true,
      dots: false,
      adaptiveHeight: false,
      swipeToSlide: true,
      // A lighter swipe on mobile, closer to Main Product's native scroll-snap.
      // Slick needs listWidth / touchThreshold pixels before switching slides.
      touchThreshold: window.innerWidth < 1000 ? 15 : 5
    });

    // På desktop låter vi Slick högerjustera sista bilden naturligt (1.09 slidesToShow).
    // På mobil behåller vi den befintliga 1 px- och sista-bildskorrigeringen.
    const mainSlick = $main.slick('getSlick');
    if (mainSlick && !mainSlick.mnDrawerLastSlideAligned) {
      mainSlick.mnDrawerLastSlideAligned = true;
      const originalGetLeft = mainSlick.getLeft;
      mainSlick.getLeft = function(slideIndex) {
        const defaultLeft = originalGetLeft.call(this, slideIndex);
        // Mobil: placera sista bilden kant i kant med galleriets högra sida.
        // VariableWidth vänsterjusterar annars även sista bilden och lämnar
        // det tomma 6,5 %-utrymmet (avsatt för nästa bild) till höger.
        // Läs den verkliga bredden efter slickFilter, så även materialbyte fungerar.
        const mobileVariableGallery =
          window.matchMedia('(max-width: 768px)').matches &&
          this.options?.variableWidth &&
          this.options?.infinite === false &&
          !this.options?.centerMode &&
          !this.options?.vertical;
        if (mobileVariableGallery && this.slideCount > 1 &&
            slideIndex === this.slideCount - 1 && Number.isFinite(defaultLeft)) {
          const lastSlide = this.$slideTrack?.children('.slick-slide').eq(slideIndex)?.[0];
          const list = this.$list?.[0];
          if (lastSlide && list) {
            const extraSpace = list.getBoundingClientRect().width -
              lastSlide.getBoundingClientRect().width;
            if (Number.isFinite(extraSpace) && extraSpace > 0) {
              return defaultLeft + extraSpace;
            }
          }
        }
        // Behåll den fungerande 1 px-fixen vid övergång till bild två.
        // Om bild två är den sista används i stället högerkantsjusteringen ovan.
        if (mobileVariableGallery && slideIndex === 1 && Number.isFinite(defaultLeft)) {
          return defaultLeft - 1;
        }
        return defaultLeft;
      };
    }
    if ($nav?.length) {
      $nav.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        speed: 250,
        infinite: false,
        arrows: true,
        dots: false,
        focusOnSelect: true,
        asNavFor: main
      });
    }

    /* Bildgruppering bara för produkten med fem material och Diamantkedja. */
    if (content.querySelector('.option-selector--material-cards.mn-diamond-mode')) {
      window.makApplyCurrentDrawerMediaGroup?.(content, true);
    }
    if ($main.hasClass('slick-initialized')) {
      const slick = $main.slick('getSlick');
      updateActiveMediaRatio(slick, slick.currentSlide || 0);
    }

    bindTrackpad($main);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if ($main.hasClass('slick-initialized')) $main.slick('setPosition');
        if ($nav?.hasClass('slick-initialized')) $nav.slick('setPosition');
      });
    });
  };

  const normalizeVariantText = (value) =>
    String(value || '').replace(/\s+/g, ' ').trim();

  const getSharedVariantOption = (productRoot) => {
    const variantsWrapper = productRoot?.querySelector('.mak__variants-main');
    const select = variantsWrapper?.querySelector('select[name="id"]');
    if (!variantsWrapper || !select) return null;

    const selectedValues = [];

    variantsWrapper
      .querySelectorAll('fieldset.option-selector')
      .forEach((fieldset) => {
        const checked = fieldset.querySelector('.mak_variants_radio:checked');
        if (
          checked &&
          checked.value &&
          checked.value !== 'Default Title'
        ) {
          selectedValues.push(normalizeVariantText(checked.value));
        }
      });

    const selectedTitle = selectedValues.join(' / ');

    return (
      Array.from(select.options).find((option) => {
        const optionTitle = normalizeVariantText(
          option.getAttribute('data-name') || option.textContent
        );
        return optionTitle === selectedTitle;
      }) ||
      select.selectedOptions?.[0] ||
      null
    );
  };

  const goToVisibleSharedMedia = (productRoot, mediaId) => {
    if (!mediaId || !window.jQuery?.fn?.slick) return;

    const $ = window.jQuery;
    const main = productRoot.querySelector('.product-main-slider');
    const nav = productRoot.querySelector('.product-nav-slider');
    if (!main) return;

    const goTo = ($slider) => {
      if (!$slider?.length || !$slider.hasClass('slick-initialized')) return;

      const slick = $slider.slick('getSlick');
      const visibleSlides = slick?.$slides ? slick.$slides.toArray() : [];
      const index = visibleSlides.findIndex((slide) => {
        const id = String(
          slide.getAttribute('data-image-id') ||
          slide.getAttribute('data-media-id') ||
          ''
        );
        return id === String(mediaId);
      });

      $slider.slick('slickGoTo', index >= 0 ? index : 0, true);
      $slider.slick('setPosition');
    };

    goTo($(main));
    if (nav) goTo($(nav));
  };

  // On pages without an initial PDP gallery, the scripts embedded in
  // pdp-gallery.liquid inside Shopify <template> nodes never execute. The
  // shared drawer must then perform the same material filtering / variant
  // image selection itself, for BOTH the free-gift and cart-recommendation
  // flows. On product pages pdp-gallery already handles these changes and is
  // left entirely in charge, avoiding duplicate Slick mutations.
  // Använd samma reservgrupp som pdp-gallery för femmaterialsprodukter.
  // På sidor med endast en klonad drawer körs inte pdp-gallery-scriptet.
  const getSharedSilverPlatingMediaGroups = (root, main, material, imageId) => {
    const groups = [material, '__all__'];
    if (material !== 'Silverplätering' ||
        !root.querySelector('.option-selector--material-cards.mn-diamond-mode')) {
      return groups;
    }
    const slides = [...main.querySelectorAll('.main-pdp:not(.slick-cloned)')];
    const available = new Set(slides.map((slide) => slide.getAttribute('data-media-material') || ''));
    const match = imageId ? slides.find((slide) =>
      slide.getAttribute('data-image-id') === String(imageId)) : null;
    const imageGroup = match?.getAttribute('data-media-material') || '';
    if (/silver|sterling|925|rostfritt|stål|stal|steel/i.test(imageGroup)) {
      groups.push(imageGroup);
    }
    if (groups.every((group) => group === '__all__' || !available.has(group))) {
      const fallback = ['Rostfritt stål', '925 Sterling Silver', 'Sterling Silver', 'Silver'];
      const chosen = fallback.find((group) => available.has(group)) ||
        [...available].find((group) => /silver|sterling|925|rostfritt|stål|stal|steel/i.test(group));
      if (chosen) groups.push(chosen);
    }
    return groups;
  };

  const syncSharedGalleryWithoutPdpScript = (productRoot, mediaId) => {
    if (typeof window.makResetPdpGalleryState === 'function') return;
    if (!window.jQuery?.fn?.slick) return;

    const $ = window.jQuery;
    const gallery = productRoot.querySelector('.new-slider');
    const main = productRoot.querySelector('.product-main-slider');
    const nav = productRoot.querySelector('.product-nav-slider');
    if (!gallery || !main) return;

    // Vanliga produkter visar alla bilder. Behåll bara byte till vald variantbild.
    if (!productRoot.querySelector('.option-selector--material-cards.mn-diamond-mode')) {
      goToVisibleSharedMedia(productRoot, mediaId);
      return;
    }

    const $main = $(main);
    if (!$main.hasClass('slick-initialized')) return;
    const $nav = nav ? $(nav) : null;

    const materialIndex = Number(gallery.getAttribute('data-material-index'));
    const materialInput = productRoot.querySelector(
      '.option-selector--material-cards .mak_variants_radio:checked, ' +
      '.mak_variants_radio.pdp-material:checked, ' +
      '.mak_variants_radio.pdp-farg:checked'
    );
    const material = materialInput?.value || '';
    let materialChanged = false;

    if (Number.isInteger(materialIndex) && materialIndex >= 0 && material &&
        productRoot.dataset.mnSharedGalleryMaterial !== material) {
      $main.slick('slickUnfilter');
      if ($nav?.hasClass('slick-initialized')) $nav.slick('slickUnfilter');
      const allowedGroups = getSharedSilverPlatingMediaGroups(productRoot, main, material, mediaId);
      const hasMatchingMedia = [...main.querySelectorAll('.main-pdp:not(.slick-cloned)')]
        .some((slide) => allowedGroups.includes(slide.getAttribute('data-media-material') || ''));
      const filter = ($slider) => {
        if (!$slider?.hasClass('slick-initialized')) return;
        // Slick keeps old indices after filtering; normalize them as the
        // existing pdp-gallery code does, so the first mobile swatch change
        // always lands on the intended slide.
        const normalize = () => {
          $slider.slick('getSlick')?.$slides?.each((index, slide) => {
            slide.setAttribute('data-slick-index', index);
          });
        };
        normalize();
        if (hasMatchingMedia || material !== 'Silverplätering' ||
            !productRoot.querySelector('.option-selector--material-cards.mn-diamond-mode')) {
          $slider.slick('slickFilter', function () {
            return allowedGroups.includes(this.getAttribute('data-media-material') || '');
          });
          normalize();
        }
        $slider.slick('setPosition');
      };

      filter($main);
      filter($nav);
      productRoot.dataset.mnSharedGalleryMaterial = material;
      materialChanged = true;
    }

    // When only the chain / letter changes, keep the existing material
    // filter and simply show that variant's featured image.
    goToVisibleSharedMedia(productRoot, mediaId);
    if (materialChanged && window.matchMedia('(max-width: 999px)').matches) {
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (productRoot.isConnected) {
          goToVisibleSharedMedia(productRoot, mediaId);
        }
      }));
    }
  };

  // Håll materialkortens visade priser synkade med vald kedja och övriga val.
  // Inline-script i en klonad <template> / dynamiskt laddad drawer körs inte.
  const syncSharedMaterialCardPrices = (variantsWrapper) => {
    const group = variantsWrapper?.querySelector('.option-selector--material-cards');
    if (!group) return;

    const materialIndex = Number(group.dataset.mnOptionIndex);
    if (!Number.isInteger(materialIndex)) return;

    const jsonEl = variantsWrapper.querySelector('[data-mn-drawer-variants]');
    let variants = [];
    let formatted = {};
    if (jsonEl) {
      try {
        const data = JSON.parse(jsonEl.textContent);
        if (Array.isArray(data.variants)) variants = data.variants;
        if (data.formatted && typeof data.formatted === 'object') formatted = data.formatted;
      } catch (error) {
        // Reservväg nedan: läs variantpriser från produktens select.
      }
    }

    if (!variants.length) {
      const select = variantsWrapper.querySelector('select[name="id"]');
      variants = Array.from(select?.options || []).map((option) => ({
        id: option.value,
        options: String(option.getAttribute('data-name') || '').split(/\s+\/\s+/),
        drawerPrice: option.getAttribute('data-price') || ''
      }));
    }

    const selected = {};
    variantsWrapper.querySelectorAll('fieldset[data-mn-option-index]').forEach((fieldset) => {
      const checked = fieldset.querySelector('.mak_variants_radio:checked');
      if (checked) selected[Number(fieldset.dataset.mnOptionIndex)] = checked.value;
    });

    group.querySelectorAll('[data-mn-material-value]').forEach((card) => {
      const priceEl = card.querySelector('[data-mn-material-price]');
      if (!priceEl) return;
      const candidates = variants.filter((variant) =>
        Array.isArray(variant.options) &&
        variant.options[materialIndex] === card.dataset.mnMaterialValue
      );
      const matched = candidates.find((variant) =>
        variant.options.every((value, index) =>
          index === materialIndex || selected[index] === undefined || selected[index] === value
        )
      ) || candidates[0];
      if (!matched) return;
      const price = formatted[String(matched.id)]?.price || matched.drawerPrice;
      if (price) priceEl.textContent = price;
    });
  };

  // Klonade pdp-variants kör inte inline-scriptet. Synka de verkliga Shopify-valen här.
  const syncSharedDiamondMaterial = (variantsWrapper) => {
    const group = variantsWrapper?.querySelector('.option-selector--material-cards.mn-diamond-mode');
    const chainGroup = variantsWrapper?.querySelector('.option-selector--chain-cards');
    if (!group || !chainGroup) return;
    const chain = chainGroup.querySelector('.mak_variants_radio:checked');
    const diamond = chain?.value === 'Diamantkedja';
    group.classList.toggle('mn-diamond-selected', diamond);
    const current = group.querySelector('.mak_variants_radio:checked');
    const material = current?.value || '';
    let target = '';
    if (diamond && material !== 'Guldplätering' && material !== 'Silverplätering') {
      target = /guld|gold|vermeil/i.test(material) || !material ? 'Guldplätering' : 'Silverplätering';
    } else if (!diamond && material === 'Silverplätering') {
      target = 'Rostfritt stål';
    }
    if (target) {
      const radio = [...group.querySelectorAll('.mak_variants_radio')].find(input => input.value === target);
      if (radio) radio.checked = true;
    }
  };

  const syncSharedVariant = (sourceInput = null) => {
    const drawer = getDrawer();
    const content = drawer?.querySelector('[data-mn-shared-customize-content]');
    const productRoot =
      sourceInput?.closest?.('.mak__new__pdp-data') ||
      content?.querySelector('.mak__new__pdp-data');

    if (!productRoot) return;

    const variantsWrapper = productRoot.querySelector('.mak__variants-main');
    const select = variantsWrapper?.querySelector('select[name="id"]');
    syncSharedDiamondMaterial(variantsWrapper);
    const option = getSharedVariantOption(productRoot);

    if (!variantsWrapper) return;

    // Även när kunden bara byter kedja ska varje materialkort visa rätt pris.
    syncSharedMaterialCardPrices(variantsWrapper);
    if (!select || !option) return;

    select.value = option.value;
    option.selected = true;

    const variantId = option.value;
    const price = option.getAttribute('data-price') || '';
    const mediaId =
      option.getAttribute('data-image-id') ||
      sourceInput?.getAttribute('data-image-id') ||
      '';

    if (sourceInput) {
      sourceInput.setAttribute('data-variant-id', variantId);
      if (mediaId) {
        sourceInput.setAttribute('data-image-id', mediaId);
      }

      const fieldset = sourceInput.closest('fieldset.option-selector');
      const selectedText = fieldset?.querySelector(
        `label[for="${CSS.escape(sourceInput.id)}"] .js-value`
      );
      const selectedLabel = fieldset?.querySelector('.mak_slected-variant');

      if (selectedText && selectedLabel) {
        selectedLabel.textContent = selectedText.textContent.trim();
      }
    }

    productRoot
      .querySelectorAll('button[default-variant-id], button[data-variant-id]')
      .forEach((button) => {
        if (button.hasAttribute('default-variant-id')) {
          button.setAttribute('default-variant-id', variantId);
        }
        if (button.hasAttribute('data-variant-id')) {
          button.setAttribute('data-variant-id', variantId);
        }
      });

    if (price) {
      productRoot
        .querySelectorAll(
          '.mak_free-prices-normal .price__default, .mak_free-prices-normal .price__current'
        )
        .forEach((priceEl) => {
          priceEl.textContent = price;
        });
    }

    /*
     * Använd samma media-gruppering som tidigare fungerade för drawern,
     * men kör den bara EN gång från shared drawerns lokala controller.
     */
    if (variantsWrapper.querySelector('.option-selector--material-cards.mn-diamond-mode')) {
      window.makApplyCurrentDrawerMediaGroup?.(variantsWrapper);
    }
    syncSharedGalleryWithoutPdpScript(productRoot, mediaId);

    /*
     * Desktop kan synka variantbilden direkt.
     *
     * På mobil får pdp-gallery ensam sköta bildbytet efter att materialgruppen
     * har filtrerats. Om shared drawern först går till variantens ORIGINAL-index
     * och pdp-gallery därefter kör slickFilter(), behåller Slick det gamla
     * currentSlide-indexet och första materialbytet kan landa på sista bilden
     * i den nya gruppen.
     */
    if (typeof window.makResetPdpGalleryState === 'function' &&
        window.matchMedia('(min-width: 1000px)').matches) {
      requestAnimationFrame(() => {
        goToVisibleSharedMedia(productRoot, mediaId);
      });
    }
  };

  const initSharedVariantController = (content) => {
    if (content.dataset.mnSharedVariantReady === 'true') {
      syncSharedVariant();
      return;
    }

    content.dataset.mnSharedVariantReady = 'true';

    content.addEventListener('change', (event) => {
      const input = event.target.closest(
        '.mak__variants-main .mak_variants_radio'
      );
      if (!input || !content.contains(input)) return;

      syncSharedVariant(input);
    });

    syncSharedVariant();
  };

  const getMaterialValue = (root) => {
    const variants = root.querySelector('.mak__variants-main');
    if (!variants) return '';
    // Materialet ska läsas från materialkortets valda radio, inte från andra varianter.
    const selectedMaterial = variants.querySelector(
      '.option-selector--material-cards .mak_variants_radio:checked, .mak_variants_radio.pdp-farg:checked'
    );
    if (selectedMaterial) return String(selectedMaterial.value || '').trim();
    const values = [...variants.querySelectorAll('.mak_variants_radio:checked')]
      .map((input) => String(input.value || '').trim());
    return values.find((value) =>
      /guld|gold|silver|sterling|vermeil|pläter|plated|925|rostfritt|stål|stal|stainless|steel/i.test(value)
    ) || '';
  };

  const applyPreviewMaterial = (preview, value) => {
    const material = String(value || '').toLowerCase();
    // Guldpläterat rostfritt stål är guld; rent rostfritt stål och 925 är silver.
    const isSilver = /vitguld|white\s*gold/i.test(material) || (
      !/guld|gold|vermeil|pläter|plated/i.test(material) &&
      /silver|sterling|925|rostfritt|stål|stal|stainless|steel|sliver/i.test(material)
    );
    preview.classList.toggle('mar-silver', isSilver);
    preview.classList.toggle('mar-sliver', isSilver);
    preview.classList.toggle('mar-gold', !isSilver);
    preview.dataset.material = isSilver ? 'silver' : 'gold';
    // Lås gradienten till valt material även om äldre tema-CSS sätter en guldbakgrund.
    preview.style.setProperty('background-image', isSilver
      ? 'linear-gradient(#c0c0c0, #e0e0e0, #c0c0c0)'
      : 'linear-gradient(#d4b873, #f5e3bc, #d4b873)', 'important');
    preview.style.setProperty('background-clip', 'text', 'important');
    preview.style.setProperty('-webkit-background-clip', 'text', 'important');
    preview.style.setProperty('-webkit-text-fill-color', 'transparent', 'important');
    preview.style.setProperty('-webkit-text-stroke', isSilver
      ? '0.25px #a9a9a9' : '0.25px #d6ba78', 'important');
  };

  const initFontFields = (content) => {
    content.querySelectorAll('.mak-input-wrapper.mak-font-selector-normal').forEach((fontRoot) => {
      const simpleInput = fontRoot.querySelector('#personalizationInput');
      const simpleHidden = fontRoot.querySelector('#maktextInput');
      const simpleValue = fontRoot.querySelector('#maktextInput-val');
      const nameInput = fontRoot.querySelector('#personalization-field');
      const nameHidden = fontRoot.querySelector('#your-name');
      const preview = fontRoot.querySelector(
        '#makmyHeading, #myHeading, .mak-fontPreview_Valid__cpg32.inner-fontpreview-wrapper'
      );
      const previewWrap = preview?.closest('.mak-fontPreview_FontPreview__4SFiv, .fontPreview');
      const fontHidden = fontRoot.querySelector('#fontSelected');
      const productRoot = fontRoot.closest('.mak__new__pdp-data') || content;
      // Flera namn har upprepade ID:n i temats markup; hitta varje rad lokalt.
      const multiNameRows = fontRoot.querySelectorAll('.wrapper-1 > .mak-iec-input-wrapper');

      const updateSimple = () => {
        if (!simpleInput) return;
        const value = simpleInput.value || '';
        if (simpleHidden) simpleHidden.value = value;
        if (simpleValue) simpleValue.value = value;
        if (!preview) return;
        const selected =
          fontRoot.querySelector('.mak-button-wrapper-brd.mak-selected .mak-btn-i') ||
          fontRoot.querySelector('.mak-button-wrapper-brd .mak-btn-i');
        const fontFamily = selected?.getAttribute('value') || 'Laura';
        const fontCode = selected?.dataset?.name || 'B24';
        preview.textContent = value;
        preview.style.fontFamily = `"${fontFamily}"`;
        if (fontHidden) fontHidden.value = fontCode;
        const inputField = simpleInput.closest('.mak-iec-inner-text-wrapper');
        inputField?.classList.toggle('mak-partial-width', Boolean(value));
        inputField?.classList.toggle('mak-full-width', !value);
        previewWrap?.classList.toggle('mak-partial-width', Boolean(value));
        applyPreviewMaterial(preview, getMaterialValue(productRoot));
      };

      const updateMultipleNames = () => {
        if (!multiNameRows.length) return;
        const selected =
          fontRoot.querySelector('.mak-button-wrapper-brd.mak-selected .mak-btn-i') ||
          fontRoot.querySelector('.mak-button-wrapper-brd .mak-btn-i');
        const fontFamily = selected?.getAttribute('value') || 'Laura';
        const fontCode = selected?.dataset?.name || 'B24';
        if (fontHidden) fontHidden.value = fontCode;

        multiNameRows.forEach((row) => {
          const input = row.querySelector('input#maktextInput');
          if (!input) return;
          const value = input.value || '';
          const hidden = row.querySelector('input#maktextInput-val');
          const counter = row.querySelector('#mak_font-limit');
          const rowPreview = row.querySelector('#makmyHeading, .inner-fontpreview-wrapper');
          const rowPreviewWrap = rowPreview?.closest('.mak-fontPreview_FontPreview__4SFiv, .fontPreview');
          const inputField = input.closest('.mak-iec-inner-text-wrapper');
          if (hidden) hidden.value = value;
          if (counter) {
            const maxLength = Number(input.getAttribute('maxlength')) || 6;
            counter.textContent = `${value.length}/${maxLength}`;
          }
          if (rowPreview) {
            rowPreview.textContent = value;
            rowPreview.style.fontFamily = `"${fontFamily}"`;
            applyPreviewMaterial(rowPreview, getMaterialValue(productRoot));
          }
          inputField?.classList.toggle('mak-partial-width', Boolean(value));
          inputField?.classList.toggle('mak-full-width', !value);
          rowPreviewWrap?.classList.toggle('mak-partial-width', Boolean(value));
        });
      };

      const updateName = () => {
        if (!nameInput) return;
        if (nameHidden) nameHidden.value = nameInput.value || '';
        const counter = nameInput.closest('.mak-iec-inner-text-wrapper')?.querySelector('#mak_font-limit');
        const maxLength = Number(nameInput.getAttribute('maxlength')) || 6;
        if (counter) counter.textContent = `${(nameInput.value || '').length}/${maxLength}`;
      };

      simpleInput?.addEventListener('input', updateSimple);
      nameInput?.addEventListener('input', updateName);
      multiNameRows.forEach((row) => {
        row.querySelector('input#maktextInput')?.addEventListener('input', updateMultipleNames);
      });

      fontRoot.addEventListener('click', (event) => {
        const button = event.target.closest('.mak-button-wrapper-brd');
        if (!button || !fontRoot.contains(button)) return;
        fontRoot.querySelectorAll('.mak-button-wrapper-brd').forEach((item) => {
          item.classList.remove('mak-selected');
        });
        button.classList.add('mak-selected');
        updateSimple();
        updateMultipleNames();
      });

      const syncSelectedMaterialPreview = () => {
        updateSimple();
        updateMultipleNames();
      };
      productRoot.addEventListener('change', (event) => {
        if (event.target.matches('.mak_variants_radio, .mak__variants-main input[type="radio"], .mak__variants-main select')) {
          window.setTimeout(syncSelectedMaterialPreview, 0);
          window.setTimeout(syncSelectedMaterialPreview, 60);
        }
      });
      productRoot.addEventListener('click', (event) => {
        if (event.target.closest('.option-selector--material-cards label[for]')) {
          window.setTimeout(syncSelectedMaterialPreview, 0);
          window.setTimeout(syncSelectedMaterialPreview, 60);
        }
      });

      updateName();
      updateSimple();
      updateMultipleNames();
    });
  };

  const ensureGiftboxBackdrop = () => {
    if (giftboxBackdrop) return giftboxBackdrop;
    giftboxBackdrop = document.createElement('button');
    giftboxBackdrop.type = 'button';
    giftboxBackdrop.className = 'mn-builder-giftbox-backdrop';
    giftboxBackdrop.setAttribute('aria-label', 'Stäng presentförpackning');
    giftboxBackdrop.addEventListener('click', () => {
      giftbox?.querySelector('.side-drawer-header-upsell .side-pdp-close-upsell')?.click();
    });
    document.body.appendChild(giftboxBackdrop);
    return giftboxBackdrop;
  };

  // Both the cart recommendation and the free-gift product selector clone
  // pdp-gallery from inert <template> elements. Scripts in those templates do
  // not execute on non-product pages, so autoplay and click-to-play need a
  // controller here. On a main product page, leave free-gift videos to the
  // existing pdp-gallery controller; keep recommendation's current behavior.
  const initCartRecommendationVideos = (content) => {
    if (!content?.querySelector('.mn-shared-customize-context')) return;
    if (window.__mnPdpGalleryVideoControls &&
        !content.querySelector('.mn-cart-recommendation-context')) return;
    const slider = content.querySelector('.product-main-slider');
    const drawer = content.closest('[data-mn-shared-customize-drawer]');
    if (!slider || !drawer) return;

    const reveal = (video) => {
      const slide = video.closest('.mn-pdp-video-slide');
      if (!slide || !slide.classList.contains('slick-current')) return;
      const showFrame = () => {
        if (drawer.classList.contains('is-open') &&
            slide.classList.contains('slick-current') &&
            !video.paused && video.readyState >= 2) {
          slide.classList.add('mn-pdp-video-ready');
        }
      };
      if (typeof video.requestVideoFrameCallback === 'function') {
        video.requestVideoFrameCallback(showFrame);
      }
      // Safari/iOS fallback if no video-frame callback is delivered.
      window.setTimeout(showFrame, 150);
    };

    const sync = () => {
      if (!drawer.classList.contains('is-open') || !slider.isConnected || !content.contains(slider)) return;
      const active = slider.querySelector('.main-pdp.slick-current:not(.slick-cloned)') ||
        (!slider.classList.contains('slick-initialized')
          ? slider.querySelector('.main-pdp') : null);
      slider.querySelectorAll('.main-pdp video').forEach((video) => {
        const slide = video.closest('.main-pdp');
        if (slide !== active || slide.classList.contains('slick-cloned')) {
          if (!video.paused) video.pause();
          slide?.classList.remove('mn-pdp-video-ready');
          return;
        }
        video.dataset.mnSharedVideoStopped = 'false';
        video.muted = video.dataset.mnUserMuted !== 'false';
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.loop = true;
        const sound = slide.querySelector('.mn-pdp-video-sound');
        sound?.classList.toggle('is-unmuted', !video.muted);
        sound?.setAttribute('aria-label', video.muted ? 'Slå på ljud' : 'Stäng av ljud');
        if (video.paused || video.ended) {
          const result = video.play();
          if (result?.catch) result.catch(() => {});
        }
        reveal(video);
      });
    };

    const $slider = window.jQuery?.(slider);
    $slider?.off('.mnCartRecoVideo');
    $slider?.on('init.mnCartRecoVideo reInit.mnCartRecoVideo afterChange.mnCartRecoVideo setPosition.mnCartRecoVideo',
      () => window.requestAnimationFrame(sync));
    $slider?.on('beforeChange.mnCartRecoVideo', () => {
      slider.querySelectorAll('.main-pdp video').forEach((video) => {
        if (!video.paused) video.pause();
      });
    });

    slider.addEventListener('playing', (event) => {
      if (event.target.matches?.('.mn-pdp-video-slide video')) reveal(event.target);
    }, true);
    slider.addEventListener('loadeddata', (event) => {
      if (event.target.matches?.('.mn-pdp-video-slide video')) reveal(event.target);
    }, true);
    slider.addEventListener('click', (event) => {
      const sound = event.target.closest('.mn-pdp-video-sound');
      if (sound && slider.contains(sound)) {
        const video = sound.closest('.main-pdp')?.querySelector('video');
        if (!video) return;
        event.preventDefault();
        event.stopPropagation();
        video.muted = !video.muted;
        video.dataset.mnUserMuted = video.muted ? 'true' : 'false';
        sound.classList.toggle('is-unmuted', !video.muted);
        sound.setAttribute('aria-label', video.muted ? 'Slå på ljud' : 'Stäng av ljud');
        if (video.paused) {
          const result = video.play();
          if (result?.catch) result.catch(() => {});
        }
        return;
      }
      const video = event.target.closest('.mn-pdp-video-slide.slick-current video');
      if (!video || !slider.contains(video)) return;
      event.preventDefault();
      event.stopPropagation();
      if (video.paused || video.ended) {
        const result = video.play();
        if (result?.catch) result.catch(() => {});
      } else {
        video.pause();
      }
    });
    // Slick is initialized before this function; defer until the visible slide
    // is laid out, then run again after drawer opening settles.
    window.requestAnimationFrame(sync);
    window.setTimeout(sync, 180);
  };

  const stopCustomizeVideos = (content) => {
    content?.querySelectorAll('video').forEach((video) => {
      video.dataset.mnSharedVideoStopped = 'true';
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.dataset.autoplay = 'false';
      video.muted = true;
      if (!video.paused) video.pause();
    });
  };

  const restoreGiftbox = () => {
    if (giftboxObserver) {
      giftboxObserver.disconnect();
      giftboxObserver = null;
    }
    if (giftbox) {
      giftbox.classList.remove('open');
      giftbox.removeAttribute('data-mn-builder-giftbox');
      if (giftboxPlaceholder?.parentNode) {
        giftboxPlaceholder.parentNode.insertBefore(giftbox, giftboxPlaceholder);
        giftboxPlaceholder.remove();
      } else {
        giftbox.remove();
      }
    }
    giftbox = null;
    giftboxPlaceholder = null;
    giftboxBackdrop?.remove();
    giftboxBackdrop = null;
  };

  const portalGiftbox = (button) => {
    const drawer = getDrawer();
    const content = drawer?.querySelector('[data-mn-shared-customize-content]');
    const id = String(button?.dataset?.upsellId || '').trim();
    if (!content || !id) return;
    const target = content.querySelector(`#new-drawer-upsell-${id}`);
    if (!target || target === giftbox) return;
    stopCustomizeVideos(content);
    restoreGiftbox();
    giftbox = target;
    giftboxPlaceholder = document.createComment('mn-shared-giftbox-placeholder');
    target.parentNode.insertBefore(giftboxPlaceholder, target);
    target.setAttribute('data-mn-builder-giftbox', '');
    document.body.appendChild(target);
    const backdrop = ensureGiftboxBackdrop();
    giftboxObserver = new MutationObserver(() => {
      backdrop.classList.toggle('is-open', target.classList.contains('open'));
    });
    giftboxObserver.observe(target, { attributes: true, attributeFilter: ['class'] });
  };

  const close = (options = {}) => {
    if (window.makCartRecommendationMode && !options.keepGiftbox) {
      window.makCartRecommendationMode = false;
      window.makCartPendingGiftItem = null;
      document.documentElement.classList.remove('mn-cart-gift-flow');
    }
    const drawer = getDrawer();
    if (!drawer) return;
    // Låt alla Anpassa-drawers glida ut vid Tillbaka.
    // Immediate-stängning under cart/giftbox-flöden ska fortsatt vara direkt.
    drawer.classList.toggle('mn-shared-customize-closing',
      !options.immediate &&
      drawer.classList.contains('is-open') &&
      drawer.classList.contains('mn-shared-customize-slide')
    );
    const content = drawer.querySelector('[data-mn-shared-customize-content]');
    stopCustomizeVideos(content);
    if (!options.keepGiftbox) {
      restoreGiftbox();
    }
    drawer.classList.remove('is-open', 'mn-builder-drawer--settled');
    drawer.setAttribute('aria-hidden', 'true');

    const finish = () => {
      if (!drawer.classList.contains('is-open')) {
        /*
         * Lås upp sidan först när close-animationen är färdig.
         * Då kan sticky Main Product inte ändra position medan drawern/backdrop
         * fortfarande är synlig.
         */
        unlockPage();
        stopCustomizeVideos(content);
        content?.replaceChildren();
        content?.classList.remove('is-loaded', 'is-loading');
        drawer.removeAttribute('data-mn-source-pdp-id');
        drawer.classList.remove('mn-shared-customize-closing');
      }
    };

    options.immediate ? finish() : window.setTimeout(
      finish,
      drawer.classList.contains('mn-shared-customize-closing') ? 500 : 310
    );
  };

  /* Endast synlig på desktop: diskret fördelsrad i den vita ytan under bildgalleriet. */
  const addDrawerBenefits = (root) => {
    const media = root?.querySelector('.mak__new__pdp-data > .mak_pdp-top_data');
    if (!media || media.querySelector('.mn-drawer-benefits')) return;
    media.insertAdjacentHTML('beforeend', '<div class="mn-drawer-benefits" aria-label="Fördelar med att handla hos oss">\n  <div class="mn-drawer-benefits__item">\n    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"/><path d="m9 12 2 2 4-4"/></svg>\n    <span>Svenskt företag</span>\n  </div>\n  <div class="mn-drawer-benefits__item">\n    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12v10H4V12"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 1 1 2.5-2.5c0 2 2 2.5 2 2.5Z"/><path d="M12 7h4.5A2.5 2.5 0 1 0 14 4.5C14 6.5 12 7 12 7Z"/></svg>\n    <span>Personligt för dig</span>\n  </div>\n  <div class="mn-drawer-benefits__item">\n    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>\n    <span>Trygga betalningar</span>\n  </div>\n</div>');
  };

  const openFromButton = (button) => {
    const drawer = getDrawer();
    const content = drawer?.querySelector('[data-mn-shared-customize-content]');
    const template = getTemplate(button);
    if (!drawer || !content || !template) return false;

    restoreGiftbox();
    content.classList.add('is-loading');
    content.classList.remove('is-loaded');
    content.setAttribute('aria-busy', 'true');

    const fragment = template.content.cloneNode(true);
    fragment.querySelectorAll(
      'script:not([type]), script[type="text/javascript"], script[type="application/javascript"]'
    ).forEach((script) => script.remove());

    /*
     * Viktigt på Main Product:
     * pdp-variants renderar inline onchange="makUpdateDrawerVariant(this)".
     * På produktsidan finns redan en global makUpdateDrawerVariant från huvud-PDP:n.
     * Den får inte styra den gemensamma drawern, eftersom den då kör ytterligare
     * gallery/filter-logik ovanpå shared drawerns egen Slick-instans.
     */
    fragment.querySelectorAll(
      '.mak__variants-main .mak_variants_radio[onchange]'
    ).forEach((input) => {
      input.removeAttribute('onchange');
    });

    content.replaceChildren(fragment);
    addDrawerBenefits(content);
    drawer.classList.remove('mn-shared-customize-closing');
    drawer.dataset.mnSourcePdpId = String(button.dataset.pdpId || '');
    // Alla Anpassa-drawers ska glida in från höger, även på mobil.
    drawer.classList.add('mn-shared-customize-slide');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.remove('mn-builder-drawer--settled');
    // Registrera panelens stängda startläge före is-open för att undvika
    // att färdigladdade templates hoppar direkt in utan transition.
    void drawer.querySelector('.mn-builder-drawer__panel')?.offsetWidth;
    drawer.classList.add('is-open');
    lockPage();

    const context = content.querySelector('.mn-shared-customize-context');
    if (context && window.makClearFreeProductDrawerInputs) {
      window.makClearFreeProductDrawerInputs(context);
    }

    resetCustomizeDefaultVariant(content);
    initFontFields(content);
    initGallery(content);
    initSharedVariantController(content);
    initCartRecommendationVideos(content);

    content.classList.remove('is-loading');
    content.classList.add('is-loaded');
    content.setAttribute('aria-busy', 'false');

    window.setTimeout(() => {
      if (drawer.classList.contains('is-open')) {
        drawer.classList.add('mn-builder-drawer--settled');
        const $main = window.jQuery?.(content.querySelector('.product-main-slider'));
        if ($main?.hasClass('slick-initialized')) $main.slick('setPosition');
      }
    }, 500);

    return true;
  };

  document.addEventListener('click', (event) => {
    const drawer = getDrawer();
    if (!drawer) return;

    const addButton = event.target.closest('[data-mn-shared-customize-drawer] .mak__atc-upsell');
    if (addButton && drawer.contains(addButton)) {
      stopCustomizeVideos(drawer.querySelector('[data-mn-shared-customize-content]'));
    }

    const sizeGuide = event.target.closest(
      '[data-mn-shared-customize-drawer] .mak__size-guide'
    );
    if (sizeGuide && drawer.contains(sizeGuide)) {
      event.preventDefault();
      event.stopPropagation();
      const modal = document.getElementById('makSizeGuideModal');
      if (modal) {
        if (modal.parentElement !== document.body) {
          document.body.appendChild(modal);
        }
        // Modal must stay above the raised cart/free-item/customize layers as well.
        // Important overrides the Main Collection handoff's !important z-index rules.
        modal.style.setProperty('z-index', '1001010', 'important');
        modal.style.display = 'block';
      }
      return;
    }

    // Materialguidens inline-script från pdp-variants körs inte i klonade
    // templates. Hantera därför guiden här, på alla sidor där Anpassa används.
    const materialHelp = event.target.closest(
      '[data-mn-shared-customize-drawer] .mak__variants-main .mn-material-help__button'
    );
    if (materialHelp && drawer.contains(materialHelp)) {
      event.preventDefault();
      event.stopPropagation();
      const dialog = materialHelp.closest('.mak__variants-main')?.querySelector('.mn-material-modal');
      if (dialog && !dialog.open) {
        dialog.showModal();
        materialHelp.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    const materialClose = event.target.closest(
      '[data-mn-shared-customize-drawer] .mak__variants-main .mn-material-modal__close'
    );
    if (materialClose && drawer.contains(materialClose)) {
      event.preventDefault();
      event.stopPropagation();
      materialClose.closest('dialog')?.close();
      return;
    }

    const materialDialog = event.target.closest(
      '[data-mn-shared-customize-drawer] .mak__variants-main .mn-material-modal'
    );
    if (materialDialog && drawer.contains(materialDialog) && event.target === materialDialog) {
      const rect = materialDialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom) {
        event.preventDefault();
        event.stopPropagation();
        materialDialog.close();
      }
      return;
    }

    const swatchLabel = event.target.closest(
      '[data-mn-shared-customize-drawer] .mak__variants-main label[for]'
    );

    if (swatchLabel && drawer.contains(swatchLabel)) {
      const fieldset = swatchLabel.closest('fieldset');
      const targetId = swatchLabel.getAttribute('for');
      const localInput = fieldset
        ? Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(
            (input) => input.id === targetId
          )
        : null;

      if (localInput && !localInput.disabled) {
        event.preventDefault();

        if (!localInput.checked) {
          localInput.checked = true;
          localInput.dispatchEvent(new Event('input', { bubbles: true }));
          localInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        return;
      }
    }

    const closeButton = event.target.closest('[data-mn-shared-customize-close]');
    if (closeButton && drawer.contains(closeButton)) {
      event.preventDefault();
      close();
      return;
    }

  }, true);

  // Återställ hjälpknappens status även vid Escape.
  document.addEventListener('close', (event) => {
    const dialog = event.target;
    if (!dialog.matches?.('[data-mn-shared-customize-drawer] .mak__variants-main .mn-material-modal')) return;
    dialog.closest('.mak__variants-main')?.querySelector('.mn-material-help__button')
      ?.setAttribute('aria-expanded', 'false');
  }, true);

  document.addEventListener('on:cart-drawer:before-open', () => {
    window.clearTimeout(giftboxCartCloseTimer);
    giftboxCartCloseTimer = null;
    const mobileHandoff = window.matchMedia('(max-width: 768px)').matches;

    const drawer = getDrawer();
    if (drawer?.classList.contains('is-open')) {
      /* Desktop: stäng Anpassa och giftbox direkt före varukorgen.
         Mobil: behåll giftboxen under varukorgens öppningsanimation. */
      close({ immediate: true, keepGiftbox: mobileHandoff });
    } else if (!mobileHandoff && giftbox) {
      // Giftbox kan vara öppen trots att Anpassa redan stängts.
      restoreGiftbox();
    }

    if (!mobileHandoff) {
      /* Main Product har även en separat giftbox-drawer. Stoppa eventuell
         utgående slide innan cart drawerns öppningsanimation börjar. */
      const productGiftbox = document.querySelector('.main-product-gift-product');
      if (productGiftbox) {
        productGiftbox.style.setProperty('transition', 'none', 'important');
        productGiftbox.classList.remove('open');
        void productGiftbox.offsetWidth;
        window.requestAnimationFrame(() => {
          if (!productGiftbox.classList.contains('open')) {
            productGiftbox.style.removeProperty('transition');
          }
        });
      }
    }
  });

  document.addEventListener('on:cart-drawer:after-open', () => {
    // Endast mobil använder fördröjd stängning bakom varukorgen.
    if (!window.matchMedia('(max-width: 768px)').matches || !giftbox) return;
    giftboxCartCloseTimer = window.setTimeout(() => {
      restoreGiftbox();
      giftboxCartCloseTimer = null;
    }, 500);
  });

  window.mnSharedCustomizeDrawer = {
    openFromButton,
    openGiftboxFromButton(button) {
      portalGiftbox(button);
      return giftbox;
    },
    close
  };
})();
